// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=0e7e35c0-172f-4f38-8cb4-efd6f2d97351";
};